const getLowestEndpointPrice = (endpoints) => {
    const pricesArray = endpoints ? endpoints.map(e => e.price).sort((a, b) => a - b) : [];
    if (pricesArray.length) {
        return pricesArray[0];
    } else {
        return null;
    }
};

export default getLowestEndpointPrice;